import { useState } from 'react';

import { Container, DismissButton, ApproveButton, SnoozeButton } from './SuggestionsButtonsStyles';

interface SuggestionsButtonsProps {
  handleDismiss: () => void;
  handleSnooze: () => void;
  handleApprove: () => void;
  disabled: boolean;
}

const SuggestionsButtons = ({
  handleDismiss,
  handleSnooze,
  handleApprove,
  disabled
}: SuggestionsButtonsProps) => {
  const [isDismissedPressed, setIsDismissedPressed] = useState(false);
  const [isSnoozePressed, setIsSnoozePressed] = useState(false);
  const [isApprovedPressed, setIsApprovedPressed] = useState(false);

  return (
    <Container className="suggestions-buttons">
      <DismissButton
        className="dismiss-btn"
        onClick={handleDismiss}
        isPressed={isDismissedPressed}
        onMouseDown={() => setIsDismissedPressed(true)}
        onMouseUp={() => setIsDismissedPressed(false)}
        onMouseLeave={() => setIsDismissedPressed(false)}
      >
        <span role="img" aria-label="dismiss">
          ❌
        </span>
        Dismiss
      </DismissButton>

      <SnoozeButton
        className="snooze-btn"
        onClick={handleSnooze}
        isPressed={isSnoozePressed}
        onMouseDown={() => setIsSnoozePressed(true)}
        onMouseUp={() => setIsSnoozePressed(false)}
        onMouseLeave={() => setIsSnoozePressed(false)}
      >
        Snooze
      </SnoozeButton>

      <ApproveButton
        className="approve-btn"
        disabled={disabled}
        onClick={handleApprove}
        isPressed={isApprovedPressed}
        onMouseDown={() => setIsApprovedPressed(true)}
        onMouseUp={() => setIsApprovedPressed(false)}
        onMouseLeave={() => setIsApprovedPressed(false)}
      >
        <span role="img" aria-label="approve">
          ✅
        </span>
        Yes, do it
      </ApproveButton>
    </Container>
  );
};

export default SuggestionsButtons;
